<template>
  <app-base-main
    :hasMagin="false"
    :no-padding="true"
    parentTable
    :table-border-top="true"
    :table-shadow="false">
    <template #filter-group>
      <app-filter-group 
        advancedFiltering
        :fixWidth="200"
        :screenOptons="screenOptons"
        @determine="filterQuery"
        @clear="filterQuery"
        @query="$gjNoticeQuery" 
        @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SB"></ad-campaign-select>
        <gj-select
          v-model="filter.matchType"
          :options="AdKeywordEnum.SB.matchTypeOption"
          placeholder="匹配类型"
        ></gj-select>
        <gj-select
          v-if="!inCampaign && !inGroup"
          v-model="filter.adFormat"
          :options="targetingTypeOption"
          placeholder="活动类型"
        ></gj-select>
        <gj-select-input
          v-model="filter.query"
          :options="[
            { id: 0, text: '模糊查询' },
            { id: 1, text: '精准查询' },
          ]"
          :placeholder="['', '用户搜索词']"
          :width="['100px', '120px']"
        ></gj-select-input>
        <gj-select-input
          v-model="filter.keyword"
          :options="[
            { id: 0, text: '模糊查询' },
            { id: 1, text: '精准查询' },
          ]"
          :placeholder="['', '关键词']"
          :width="['100px', '100px']"
        ></gj-select-input>
        <gj-date-picker
          v-model="filter.date"
          type="daterange"
          :clearable="false"
          tooltip="数据时间"
          :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSbCampaigns:update')" #right>
          <gj-tool-group
            :helpName="helpName"
            help
            setting
            :table-name="tableName"
            :table-columns="columns"
            :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbSearchKeywords/export" :download-params="globalParams"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSbCampaigns:update')" #operate-group>
      <gj-button :disabled="noSelect" @click="setKeyword">
        设为关键词
      </gj-button>
      <gj-button :disabled="noSelect" @click="setNegKeyword">
        设为否定关键词
      </gj-button>
    </template>
    <template v-if="$permission('adsSbCampaigns:update')" #tool-group>
      <gj-tool-group
        :helpName="helpName"
        help
        setting
        :table-name="tableName"
        :table-columns="columns" :sort-gjtable="$refs.gjTable"
        :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbSearchKeywords/export" :download-params="globalParams"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
        ref="gjTable"
        adaptParent
        :name="tableName"
        :selection="$permission('adsSbCampaigns:update')"
        size="has-picture"
        :loading="loading"
        :data="tableData"
        :columns="columns"
        sortable="custom"
        :pagination="pagination"
        show-summary
        :show-overflow="true"
        :default-sort="defaultSort"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:query="{ row }">
          <div>
            <img src="./img/neg.png" class="negImg" v-if="row.negative === 0" />
            <gj-link
              :href="row.amazonQueryUrl"
              target="_blank"
              :class="[row.negative === 1 && 'notNeg']">
              <gj-tooltip :text-line="2" :content="row.query">
                {{ row.query | defaultShow }}
              </gj-tooltip>
            </gj-link>
          </div>
        </template>
        <template v-slot:keywordText="{ row }">
            <gj-link :href="row.amazonUrl" target="_blank">
              <gj-tooltip :text-line="2" :content="row.keywordText">
                {{row.keywordText | defaultShow }}
              </gj-tooltip>
            </gj-link>
        </template>
        <template v-slot:belongCampaign="{ row }">
          <app-sb-ad-route-link :ad-campaign-manager="{ marketId, campaign: row }" >
            <gj-tooltip :text-line="2" :content="row.campaignName">
              {{ row.campaignName | defaultShow }}
            </gj-tooltip>
          </app-sb-ad-route-link>
        </template>
        <template v-slot:belongGroup="{ row }">
          <app-sb-ad-route-link :ad-group-manager="{ marketId, campaign: row, group: row }" >
            <gj-tooltip :text-line="2" :content="row.groupName">
              {{ row.groupName | defaultShow }}
            </gj-tooltip>
          </app-sb-ad-route-link>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { AdCampaignEnum, AdKeywordEnum, AdSearchWordEnum } from "modules/ad/common/enum";
import { isMeaningful, isMeaningless, defaultVal } from "@/utils/common";
import AppSbAdRouteLink from "../../common/components/ad-route-link";
import AppSetKeywordModal from "../../common/modal/set-keyword/set-keyword-modal";
import AppSetNegKeywordModal from "../../common/modal/set-keyword/set-neg-keyword-modal";
import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
import { adFields } from "modules/ad/common/fields";
import { adStore } from "modules/ad/common/store";
import { convertToDate } from "@/utils/date.util";
import { SB } from "@/api/ad";
import { queryMixin, selectionMixin } from "@/minxins";
import { subDays } from "date-fns";
import {
  adDefaultSortMixin,
  adAdvancedFilteringMixin,
  currencySymbolMixin,
  inCampaignMixin,
  inGroupMixin,
  initDateMixin,
  inMarketMixin,
  inPortfolioMixin,
  resizeMixin,
  tableNameMixin,
} from "modules/ad/common/mixin";

export default {
  name: "app-sb-ad-search-keyword",
  components: { AppSbAdRouteLink , AdCampaignSelect},
  mixins: [
    inMarketMixin,
    inPortfolioMixin,
    resizeMixin,
    inCampaignMixin,
    inGroupMixin,
    tableNameMixin,
    selectionMixin,
    queryMixin,
    currencySymbolMixin,
    adDefaultSortMixin,
    adAdvancedFilteringMixin,
    initDateMixin,
  ],
  created() {
    this.columns = [
      { ...adFields.searchWordName, minWidth: "300px", help: "部分广告数据需要48小时才能更新完整，所以在某些时间范围内数据会有所延迟"},
      { ...adFields.keywordName, fixed: null },
      { ...adFields.matchType, options: AdKeywordEnum.SB.matchTypeOption },
      this.inCampaign ? null : { ...adFields.campaignType, field: "option(badge):adFormat", options: this.targetingTypeOption },
      this.inCampaign ? null : adFields.belongCampaign,
      adFields.impressions,
      adFields.clicks,
      adFields.ctr,
      adFields.cost,
      adFields.cpc,
      adFields.orders,
      adFields.cvr,
      adFields.cpa,
      adFields.sales,
      adFields.acos,
      adFields.roas,
    ].filter((e) => e !== null);
  },
  data() {
    return {
      campaignIds: [],
      helpName:'sbadmanager',
      tableData: [],
      columns: [],
      AdKeywordEnum: AdKeywordEnum,
      AdSearchWordEnum: AdSearchWordEnum,
      AdCampaignEnum: AdCampaignEnum,
      filter: {
        matchType: null,
        effectivenessType: null,
        adFormat: null,
        query: {
          key: 0,
          value: null,
        },
        keyword: {
          key: 1,
          value: null,
        },
        extendSearch: null,
        date: [subDays(new Date(), 6), new Date()],
      },
      targetingTypeOption: [
        {id: 0, text: '普通广告', color: '#5986fb'},
        {id: 1, text: '视频广告', color: '#34bfa3'},
      ],
      // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
      filterStoragekey: 'app-sb-ad-search-keyword',
      notStorage: true
    };
  }, 
  methods: {
    marketChange(marketId) {
      if (isMeaningful(marketId)) {
        this.$gjNoticeQuery();
      }
    },
    portfolioChange(portfolioId) {
      this.$gjNoticeQuery();
    },
    campaignChange(campaignId) {
      this.$gjNoticeQuery();
    },
    groupChange(groupId) {
      this.$gjNoticeQuery();
    },
    $gjQueryInitParams() {
      return {
        campaignIds: [],
        filter: {
          matchType: null,
          effectivenessType: null,
          campaignType: null,
          keyword: {
            key: 0,
            value: null,
          },
          query: {
            key: 0,
            value: null,
          },
          extendSearch: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()],
        },
      };
    },
    $gjQuery() {
      if (isMeaningless(this.marketId)) {
        return;
      }
      // 构造查询参数
      const params = {
        model: {
          campaignIds: this.campaignIds,
          marketId: this.marketId,
          portfolioId: this.portfolioId,
          campaignId: this.campaignId,
          groupId: this.groupId,
          extendSearch: this.filter.extendSearch,
          adFormat: defaultVal(this.filter.adFormat, null),
          matchType: defaultVal(this.filter.matchType, null),
          searchType: isMeaningful(this.filter.query.value) ? this.filter.query.key : null,
          query: isMeaningful(this.filter.query.value) ? this.filter.query.value : null,
          keywordSearchType: isMeaningful(this.filter.keyword.value)
            ? this.filter.keyword.key
            : null,
          keywordText: isMeaningful(this.filter.keyword.value)
            ? this.filter.keyword.value
            : null,
          startDate: convertToDate(this.filter.date[0]),
          endDate: convertToDate(this.filter.date[1]),
        },
        ...this.queryPagination,
        ...this.querySortEx,
      };
      this.globalParams = params;
      // 查询
      this.loading = true;
      SB.adsSbSearchKeywordsPage(params)
        .then(({ data }) => {
          if (isMeaningful(data)) {
            this.tableData = this.currencySymbolMixin(
              data.records,
              adStore.SB.currencySymbol
            );
            this.pagination = this.getPagination(data);
          }
        })
        .complete(() => {
          this.loading = false;
        });
    },
    // 设为关键词
    setKeyword() {
      this.$gjCreate(AppSetKeywordModal, {
        props: {
          marketId: this.marketId,
          items: this.selectedRows,
        },
        on: {
          created:() => {
            this.$gjResetPage();
          },
        },
      });
    },
    // 设为否定关键词
    setNegKeyword() {
      this.$gjCreate(AppSetNegKeywordModal, {
        props: {
          marketId: this.marketId,
          items: this.selectedRows,
        },
        on: {
          created:() => {
            this.$gjResetPage();
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">

.negImg {
  width: 24px;
  position: relative;
  top: 5px;
  margin-right: 2px;
}
.notNeg {
  margin-left: 26px;
}
</style>
